import { useEffect, useState } from "react";

export default function About({ lang }) {
  
  const [about, setAbout] = useState(null);
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    fetch("/api/admin/assets/texts.php")
      .then(res => res.json())
      .then(data => {
        // On cherche le texte "about"
        const aboutText = data.find(item => item.title === "Biographie");
        setAbout(aboutText);
      })
      .catch(err => {
        console.error("Erreur chargement about", err);
      });
  }, []);

  useEffect(() => {
    fetch("/api/admin/assets/images.php")
      .then(res => res.json())
      .then(data => {
        const photo = data.find(item => item.name === "bio_photo");
        setPhoto(photo);
      })
      .catch(err => {
        console.error("Erreur chargement photo", err);
      });
  }, []);

  return (
    <section id="about">
      <div className='container' style={{maxWidth:'700px', marginBottom:'3rem'}}>
        <div className='container mt-4' style={{marginBottom:'3rem'}}>
          <figure className="mb-0">
              <img
                src={photo?.image}
                className="img-fluid"
                alt=""
              />
              <figcaption className="photo-credit">
                @ Martin Roux, 2026
              </figcaption>
          </figure>
        </div>
        <p style={{textAlign:'justify', whiteSpace: "pre-line"}}>
          {about
            ? (lang === "fr" ? about.text : about.text_en)
            : "Loading..."}
        </p>
      </div>
    </section>
  );
}